const Main = resolve => require(["@/components/main/Main.vue"], resolve);
const Main1 = resolve => require(["@/components/main/Main1.vue"], resolve);
const shopMain = resolve => require(["@/components/main/shopMain.vue"], resolve);

const productMain = resolve => require(["@/module/quickorder/productMain.vue"], resolve);

//主页
const Home = resolve => require(["@/module/home/Home.vue"], resolve);
const Home1 = resolve => require(["@/module/home/Home1.vue"], resolve);
const EditApply = resolve => require(["@/module/home/editApply.vue"], resolve);

//消息
const Message = resolve => require(["@/module/message/messageList.vue"], resolve);

//分类
const MenuList = resolve => require(["@/module/menu/MenuList.vue"], resolve);
//公告管理
const NoticeList = resolve =>
  require(["@/module/notice/noticeList.vue"], resolve);
const NoticeView = resolve =>
  require(["@/module/notice/noticeView.vue"], resolve);

// 协议管理
const AgreementList = resolve =>
  require(["@/module/agreementManagement/agreementList.vue"], resolve);
const AgreementView = resolve =>
  require(["@/module/agreementManagement/agreementView.vue"], resolve);
const AgreementRenew = resolve =>
  require(["@/module/agreementManagement/AgreementRenew.vue"], resolve);
const AgreementRenewList = resolve =>
  require(["@/module/agreementManagement/agreementRenewList.vue"], resolve);
const AgreementRenewView = resolve =>
  require(["@/module/agreementManagement/agreementRenewView.vue"], resolve);
//订单管理
const ShipmentList = resolve =>
  require(["@/module/shipment/shipmentList.vue"], resolve);
const ShipmentView = resolve =>
  require(["@/module/shipment/shipmentView.vue"], resolve);
const ShipmentSN = resolve =>
  require(["@/module/shipment/shipmentSN.vue"], resolve);
const ShipmentLicense = resolve =>
  require(["@/module/shipment/ShipmentLicense.vue"], resolve);
const InvoiceList = resolve =>
  require(["@/module/invoice/invoiceList.vue"], resolve);
const InvoiceView = resolve =>
  require(["@/module/invoice/invoiceView.vue"], resolve);
const InvoiceLine = resolve =>
  require(["@/module/invoice/invoiceLine.vue"], resolve);
const InvoiceCreate = resolve =>
  require(["@/module/invoice/invoiceCreate.vue"], resolve);
const BillingList = resolve =>
  require(["@/module/billing/billingList.vue"], resolve);
const BillingView = resolve =>
  require(["@/module/billing/billingView.vue"], resolve);
const ContractList = resolve =>
  require(["@/module/contract/ContractList.vue"], resolve);
const ContractView = resolve =>
  require(["@/module/contract/ContractView.vue"], resolve);
//客户管理
const CustomerList = resolve =>
  require(["@/module/customer/customerList.vue"], resolve);
const CustomerView = resolve =>
  require(["@/module/customer/customerView.vue"], resolve);
const CreateAccount = resolve =>
  require(["@/module/customer/createAccount.vue"], resolve);
const NewAccount = resolve =>
  require(["@/module/customer/newAccount.vue"], resolve);
//产品试用申请
const productTrialList = resolve =>
  require(["@/module/productTrial/productTrialList.vue"], resolve);
   const productTrialView = resolve =>
      require(["@/module/productTrial/productTrialView.vue"], resolve);
//财务信息
const FinancialList = resolve =>
  require(["@/module/customer/financialList.vue"], resolve);
const FinancialEdit = resolve =>
  require(["@/module/customer/financialUpdate.vue"], resolve);
//电子授权函
const AuthorizationList = resolve =>
  require(["@/module/customer/authorizationList.vue"], resolve);
//地址信息
const AddressList = resolve =>
  require(["@/module/customer/addressList.vue"], resolve);
const CreateAddress = resolve =>
  require(["@/module/customer/createAddress.vue"], resolve);
const AddressView = (resolve) =>
  require(["@/module/customer/addressView.vue"], resolve);
const SaleOrderList = resolve =>
  require(["@/module/order/saleorderList.vue"], resolve);
const SaleOrderView = resolve =>
  require(["@/module/order/saleorderView.vue"], resolve);

const ShoppingMallChooseProduct = resolve =>
  require(["@/module/quickorder/chooseProduct.vue"], resolve);
const ShoppingMallSearchProduct = resolve =>
  require(["@/module/quickorder/searchProduct.vue"], resolve);
const ProductDetail = resolve =>
  require(["@/module/quickorder/productDetail.vue"], resolve);
const OrderConfirm = resolve =>
  require(["@/module/quickorder/confirm.vue"], resolve);
const OrderComplete = resolve =>
  require(["@/module/quickorder/complete.vue"], resolve);
const ShoppingMallImportProduct = resolve =>
  require(["@/module/quickorder/importProduct.vue"], resolve);

//物料申请
const materialViews = resolve =>
  require(["@/module/material/materialView.vue"], resolve);
const materialLists = resolve =>
  require(["@/module/material/materialList.vue"], resolve);
const materialAdds = resolve =>
  require(["@/module/material/materialAdd.vue"], resolve);

const ForecastList = resolve =>
  require(["@/module/forecast/forecastList.vue"], resolve);
const ForecastView = resolve =>
  require(["@/module/forecast/forecastView.vue"], resolve);

const ProductCatalogList = resolve =>
  require(["@/module/productCatalog/productCatalogList.vue"], resolve);
const ChannelOrder = resolve =>
  require(["@/module/productCatalog/channelorder.vue"], resolve);

const FileDownloadList = resolve =>
  require(["@/module/filedownload/filedownloadList.vue"], resolve);
const FileDownloadView = resolve =>
  require(["@/module/filedownload/filedownloadView.vue"], resolve);

// 产品大全
const ProductList = resolve => require(["@/module/productManage/index.vue"], resolve);
// 产品大全详情页
const ProductDetails = resolve => require(["@/module/productManage/productDetail.vue"], resolve);
// 产品大全文件夹页
const ProductFile = resolve => require(["@/module/productManage/productFile.vue"], resolve);
// 产品大全文件列表页
const ProductDownload = resolve => require(["@/module/productManage/productDownload.vue"], resolve);


const ForcecastReport = resolve =>
  require(["@/module/forecast/forcecastReport.vue"], resolve);

const SalesmanList = resolve =>
  require(["@/module/salesman/salesmanList.vue"], resolve);
const SalesmanView = resolve =>
  require(["@/module/salesman/salesmanView.vue"], resolve);
const SalesmanEdit = resolve =>
  require(["@/module/salesman/salesmanEdit.vue"], resolve);

const CreateOpportunity = resolve =>
  require(["@/module/opportunity/createOpportunity.vue"], resolve);
const OpportunityList = resolve =>
  require(["@/module/opportunity/opportunityList.vue"], resolve);
const OpportunityEdit = resolve =>
  require(["@/module/opportunity/opportunityEdit.vue"], resolve);

// 报价管理
const QuoteList = resolve =>
  require(["@/module/quote/quoteList.vue"], resolve);
const QuoteView = resolve =>
  require(["@/module/quote/quoteView.vue"], resolve);

//补件申请
const ResissueApplicationList = resolve =>
  require([
    "@/module/resissueapplication/resissueApplicationList.vue"
  ], resolve);
const ResissueApplicationDetail = resolve =>
  require([
    "@/module/resissueapplication/resissueApplicationDetail.vue"
  ], resolve);
const QuickOrderList = resolve =>
  require([
    "@/module/quickorder/quickOrderList.vue"
  ], resolve);
const ProPriceList = resolve =>
  require([
    "@/module/proprice/propriceList.vue"
  ], resolve);
const ProPriceView = resolve =>
  require([
    "@/module/proprice/propriceView.vue"
  ], resolve);

//临时额度申请
const TempcreditList = resolve =>
  require(["@/module/tempcredit/tempcreditList.vue"], resolve);
const TempcreditView = resolve =>
  require(["@/module/tempcredit/tempcreditView.vue"], resolve);

//费用申请
const CostapplyList = resolve =>
  require(["@/module/costapply/costapplyList.vue"], resolve);
const CostapplyView = resolve =>
  require(['@/module/costapply/costapplyView.vue'], resolve);

//返利管理
const RebatedetailList = resolve =>
  require(['@/module/rebatedetail/rebatedetailList.vue'], resolve);

//财务管理   对账单
const AccountStatementList = resolve =>
  require(['@/module/accountstatement/accountstatementList.vue'], resolve);

const AccountStatementDetail = resolve =>
  require(['@/module/accountstatement/accountstatementDetail.vue'], resolve);
const ResetPasswordView = resolve =>
  require(['@/module/resetpassword/ResetPasswordView.vue'], resolve);
const ShoppingCartList = resolve =>
  require(['@/module/quickorder/shoppingCartList.vue'], resolve);

//报价单配置
const QuotationConfigList = resolve => require(['@/module/quotationconfig/quotationConfigList.vue'], resolve);
const QuotationConfigDetail = resolve => require(['@/module/quotationconfig/quotationConfigDetail.vue'], resolve);

//市场活动费申请单
const applicationList = resolve =>
  require(["@/module/application/applicationList.vue"], resolve);
const Createapplication = resolve =>
  require(["@/module/application/Createapplication.vue"], resolve);
//渠道库存
const inventoryList = resolve =>
  require(["@/module/inventory/inventoryList.vue"], resolve);
//库存管理详情页
const inventoryView = resolve =>
  require(["@/module/inventory/inventoryView.vue"], resolve);
//OUT单
const out_orderList = resolve =>
  require(["@/module/out_order/out_orderList.vue"], resolve);
const statement = resolve =>
  require(["@/module/statement/statementList.vue"], resolve);
const outorderView = resolve =>
  require(["@/module/out_order/outorderView.vue"], resolve);
const outorderLicense = resolve =>
  require(["@/module/out_order/outorderLicense.vue"], resolve);
//验收单
const acceptanceList = resolve =>
  require(["@/module/acceptance/acceptanceList.vue"], resolve);
const acceptanceView = resolve =>
  require(["@/module/acceptance/acceptanceView.vue"], resolve);

// 报价下单
const QuoteOrder = resolve =>
  require(["@/module/quoteOrder/index.vue"], resolve);

// 报价下单
const QuoteOrderBox = resolve =>
  require(["@/module/quoteOrder/box.vue"], resolve);

//借测授权查询
const PrototypeLicense = resolve =>
  require(["@/module/productTrial/prototype_license.vue"], resolve);

//出库sn码物流查询
const PrototypeSN = resolve =>
  require(["@/module/productTrial/prototype_sn.vue"], resolve);

//商机跟进记录详情页
const OpportunityFollowUpView = resolve =>
  require(["@/module/opportunity/opportunityFollowUpView.vue"], resolve);

export default [{
  path: "/",
  component: Home,
  children: [{
    path: "/",
    name: "home",
    meta: {
      keepAlive: true,
      allowAnonymous: true
    },
    component: Home
  }]
},
{
  path: "/home1",
  component: getViews("Main"),
  children: [{
    path: "/home1",
    name: "home1",
    component: Home1
  }]
},
{
  path: "/edit",
  component: getViews("Main"),
  children: [{
    path: "apply",
    name: "editApply",
    component: EditApply
  }]
},
{
  path: "/message",
  component: getViews("Main"),
  children: [{
    path: "message",
    name: "message",
    meta: {
      keepAlive: true
    },
    component: Message
  }]
},
{
  path: "/menu",
  component: getProductViews("productMain"),
  children: [{
    path: "menulist",
    name: "menu-list",
    meta: {
      allowAnonymous: true
    },
    component: MenuList
  }]
},
{
  path: "/notice",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "NoticeList",
    component: NoticeList
  },
  {
    path: "view/:id",
    name: "notice-detail",
    component: NoticeView
  }
  ]
},
{
  path: "/agreement",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "agreementList",
    component: AgreementList
  },
  {
    path: "view/:id",
    name: "agreement-detail",
    component: AgreementView
  },
  {
    path: "renew",
    name: "agreement-renew",
    component: AgreementRenew
  },
  {
    path: "renewlist",
    name: "agreementList-renew",
    component: AgreementRenewList
  },
  {
    path: "renewview/:id",
    name: "agreementrenew-detail",
    component: AgreementRenewView
  },
  ]
},
{
  path: "/productCatalog",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "productCatalogList",
    component: ProductCatalogList
  }
  ]
},
{
  path: "/ChannelOrder",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "ChannelOrder",
    component: ChannelOrder
  }
  ]
},
{
  path: "/financial",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "financialList",
    component: FinancialList
  },
  {
    path: "view/:id",
    name: "financialEdit",
    component: FinancialEdit
  }
  ]
},
{
  path: "/authorization",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "authorizationList",
    component: AuthorizationList
  }
  ]
},

{
  path: "/address",
  component: getViews("Main"),
  children: [
    {
      path: "list",
      name: "addressList",
      component: AddressList
    },
    {
      path: "view/:id",
      name: "createAddress",
      component: CreateAddress
    },
    {
      path: "preview/:id",
      name: "addressView",
      component: AddressView,
    },
  ]
},
{
  path: "/shoppingmall",
  component: getProductViews("productMain"),
  children: [{
    path: "chooseproduct/:name?/:id?",
    name: "ShoppingMallChooseProduct",
    meta: {
      allowAnonymous: true
    },
    component: ShoppingMallChooseProduct
  },
  {
    path: "searchproduct/:name?",
    name: "ShoppingMallSearchProduct",
    meta: {
      allowAnonymous: true
    },
    component: ShoppingMallSearchProduct
  },
  {
    path: "productdetail",
    name: "product-detail",
    meta: {
      allowAnonymous: true
    },
    component: ProductDetail
  }
  ]
},
{
  path: "/shipment",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "ShipmentList",
    component: ShipmentList
  }, {
    path: "view/:id/:source?",
    name: "ShipmentView",
    component: ShipmentView
  }, {
    path: "sn/:orderId?/:shipmentId?",
    name: "ShipmentSN",
    component: ShipmentSN
  }, {
    path: "license/:entityName/:formName",
    name: "ShipmentLicense",
    component: ShipmentLicense
  }]
},
{
  path: "/invoice",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "InvoiceList",
    component: InvoiceList
  },
  {
    path: "view/:id?/:name?/:text?/:totalamount?",
    name: "InvoiceView",
    component: InvoiceView
  },
  {
    path: "line/:id",
    name: "InvoiceLine",
    component: InvoiceLine
  },
  {
    path: "create/:invoiceId/:orderId",
    name: "InvoiceCreate",
    component: InvoiceCreate
  }
  ]
},
{
  path: "/customer",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "customerList",
    component: CustomerList
  }, {
    path: "view/:id",
    name: "customerView",
    component: CustomerView
  }, {
    path: "create",
    name: "createAccount",
    component: CreateAccount
  }, {
    path: "new",
    name: "newAccount",
    component: NewAccount
  }]
},
{
  path: "/producttrial",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "productTrialList",
    component: productTrialList
  },{
    path: "view/:id",
    name: "productTrialView",
    component: productTrialView
  },{
    path: "view",
    name: "productTrialCreate",
    component: productTrialView
  },{
    path: "PrototypeLicense",
    name: "PrototypeLicense",
    component: PrototypeLicense
  },{
    path: "PrototypeSN",
    name: "PrototypeSN",
    component: PrototypeSN
  }]
},
{
  path: "/billing",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "BillingList",
    component: BillingList
  }, {
    path: "view/:id?/:name?/:text?",
    name: "BillingView",
    component: BillingView
  }]
},
{
  path: "/order",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "SaleOrderList",
    component: SaleOrderList
  },
  {
    path: ":id/:name/:time/complete",
    name: "OrderComplete",
    component: OrderComplete
  },
  {
    path: ":id/:source?/detail",
    name: "order-detail",
    component: SaleOrderView
  }
  ]
},
{
  path: "/shopcart",
  component: getViews("shopMain"),
  children: [{
    path: "list",
    name: "ShoppingCartList",
    component: ShoppingCartList
  }]

},
{
  path: "/confirm",
  component: getProductViews("OrderConfirm"),
  children: [{
    path: ":id/order",
    name: "OrderConfirm",
    component: OrderConfirm
  }]

},
{
  path: "/materialViews",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "materialView",
    component: materialViews
  }]
},
{
  path: "/materialLists",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "materialList",
    component: materialLists
  },
  {
    path: ":id/detail",
    name: "material-Views",
    component: materialViews
  },
  {
    path: ":id/Add",
    name: "material-Adds",
    component: materialAdds
  }

  ]
},

{
  path: "/quickorder",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "QuickOrderList",
    component: QuickOrderList
  },
  {
    path: "importproduct",
    meta: {
      keepAlive: true,
      allowAnonymous: true
    },
    component: ShoppingMallImportProduct
  }
  ]
},
{
  path: "/contract",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "ContractList",
    component: ContractList
  },
  {
    path: "view/:id",
    name: "ContractView",
    component: ContractView
  }
  ]
},
{
  path: "/proprice",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "ProPriceList",
    component: ProPriceList
  },
  {
    path: "create",
    name: "ProPriceCreate",
    component: ProPriceView
  },
  {
    path: "view/:id",
    name: "proprice-detail",
    component: ProPriceView
  }
  ]
},
{
  path: "/salesforecast",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "ForecastList",
    component: ForecastList
  },
  {
    path: "view/:id",
    name: "ForecastView",
    component: ForecastView
  },
  {
    path: "create",
    name: "ForecastCreate",
    component: ForecastView
  },
  {
    path: "report",
    name: "ForcecastReport",
    component: ForcecastReport
  }
  ]
},
{
  path: "/filedownload",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "FileDownloadList",
    component: FileDownloadList
  },
  {
    path: "view/:id",
    name: "FileDownloadView",
    component: FileDownloadView
  }
  ]
},
// 产品管理
{
  path: "/productData",
  component: getViews("Main"),
  children: [
    {
      path: "list",
      name: "ProductList",
      component: ProductList
    },
    {
      path: "Detail/:id",
      name: "ProductDetail",
      component: ProductDetails
    },
    {
      path: "File/:id",
      name: "ProductFile",
      component: ProductFile
    },
    {
      path: "Download/:id",
      name: "ProductDownload",
      component: ProductDownload
    }
  ]
},
{
  path: "/salesman",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "SalesmanList",
    component: SalesmanList
  },
  {
    path: "Edit/:id",
    name: "SalesmanEdit",
    component: SalesmanEdit
  },
  {
    path: "view",
    name: "SalesmanView",
    component: SalesmanView
  }
  ]
},
{
  path: "/opportunity",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "OpportunityList",
    component: OpportunityList
  },
  {
    path: "edit/:id",
    name: "OpportunityEdit",
    component: OpportunityEdit
  },
  {
    path: "create/:id?/:account?/:name?",
    name: "CreateOpportunity",
    component: CreateOpportunity
  },{
    path: "oppfollpupview/:oppfollpupviewid?",
    name: "OpportunityFollowUpView",
    component: OpportunityFollowUpView
    }
  ]
},
{
  path: '/quote',
  component: getViews('Main'),
  children: [{
    path: 'list',
    name: 'QuoteList',
    component: QuoteList
  }, {
    path: 'view/:id',
    name: 'QuoteView',
    component: QuoteView
  }]
},
{
  path: "/resissueapplication",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "ResissueApplicationList",
    component: ResissueApplicationList
  },
  {
    path: "detail/:id",
    name: "ResissueApplicationDetail",
    component: ResissueApplicationDetail
  }
  ]
},
{
  path: "/tempcredit",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "TempcreditList",
    component: TempcreditList,
  },
  {
    path: "view/:id",
    name: "tempcredit-detail",
    component: TempcreditView
  },
  {
    path: "create",
    name: "TempcreditCreate",
    component: TempcreditView
  }
  ]
},
{
  path: "/costapply",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "CostapplyList",
    component: CostapplyList
  },
  {
    path: "view/:id",
    name: "costapply-detail",
    component: CostapplyView
  },
  {
    path: "create",
    name: "CostapplyCreate",
    component: CostapplyView
  }
  ]
},
{
  path: "/rebatedetail",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "RebatedetailList",
    component: RebatedetailList
  },

  ]
},
{
  path: "/accountstatementlist",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "accountstatementList",
    component: AccountStatementList
  },

  ]
},
{
  path: "/accountstatementDetail/:id/:date",
  component: getViews("Main"),
  children: [{
    path: "detail",
    name: "accountstatement-detail",
    component: AccountStatementDetail
  },

  ]
},
{
  path: "/resetpassword",
  component: getViews("Main"),
  children: [{
    path: "view",
    name: "resetpassword-view",
    component: ResetPasswordView
  },

  ]
},
//配置报价
{
  path: '/quotationconfig/list',
  name: 'quotationconfiglist',
  meta: {
    allowAnonymous: true
  },
  component: QuotationConfigList,
},
{
  path: '/quotationconfig/create/:quoteId?',
  name: 'quotationconfigcreate',
  meta: {
    allowAnonymous: true
  },
  component: QuotationConfigDetail
},
//渠道库存
{
  path: "/inventory",
  component: getViews("Main"),
  children: [{
    path: '/inventory/list',
    name: 'inventory',
    component: inventoryList
  }, {
    path: "view/:id",
    name: "InventoryView",
    component: inventoryView
  }]
},
{
  path: "/out_order",
  component: getViews("Main"),
  children: [{
    path: '/out_order/out_orderList',
    name: 'out_order',
    component: out_orderList
  },
  {
    path: "view/:id?",
    name: "outorderView",
    component: outorderView
  },
  {
    path: "license/:entityName/:formName",
    name: "outorderLicense",
    component: outorderLicense
  }
  ]
},
{
  path: "/acceptance",
  component: getViews("Main"),
  children: [{
    path: '/acceptance/list',
    name: 'acceptance',
    component: acceptanceList
  },
  {
    path: "view/:id?/:source",
    name: "acceptanceView",
    component: acceptanceView
  },
    // {
    //   path: "license/:entityName/:formName",
    //   name: "outorderLicense",
    //   component: outorderLicense
    // }
  ]
    },
    {
        path: "/statement",
        component: getViews("Main"),
        children: [{
            path: '/statement/statementList',
            name: 'statement',
            component: statement
        }
        ]
    },
{
  path: '/quotationconfig/edit/:quoteId?/:cpqQuoteId?',
  name: 'quotationconfigedit',
  meta: {
    allowAnonymous: true
  },
  component: QuotationConfigDetail
},
//市场活动费申请单
{
  path: "/application",
  component: getViews("Main"),
  children: [
    {
      path: "list",
      name: "applicationlist",
      component: applicationList
    },
    {
      path: "view/:id",
      name: "createapplication",
      component: Createapplication
    }
  ]
},
{
  path: "/distributorPro",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "distributorProList",
    component: QuoteOrder
  }]
},
{
  path: "/businessPro",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "businessProList",
    component: QuoteOrder
  }]
},
{
  path: "/smbPro",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "smbProList",
    component: QuoteOrder
  }]
},
{
  path: "/mssPro",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "mssProList",
    component: QuoteOrder
  }]
},
{
  path: "/specPro",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "specProList",
    component: QuoteOrder
  }]
},
{
  path: "/nanoPro",
  component: getViews("Main"),
  children: [
    { path: "", redirect: "list" },
    {
      path: "list",
      name: "nanoProList",
      component: QuoteOrder
    }
  ]
},
{
  path: "/agentProBox",
  component: getViews("Main"),
  children: [{
    path: "list",
    name: "agentProBox",
    component: QuoteOrderBox
  }]
},

];
import store from '../store';
function getViews(path) {
  const isStore = store.state.isStore;
  if (isStore) {
    return resolve => require(["@/components/main/" + path + ".vue"], resolve)
  } else {
    return resolve => require(["@/components/main/Main1.vue"], resolve)
  }
}

function getProductViews(path) {
  const isStore = store.state.isStore;
  if (isStore) {
    return resolve => require(["@/module/quickorder/" + path + ".vue"], resolve)
  } else {
    return resolve => require(["@/components/main/Main1.vue"], resolve)
  }
}



// WEBPACK FOOTER //
// ./src/module/router.js